export default __webpack_public_path__ + "static/13_23-5954c36ad5735b9bf801ef09530e2dab.png";